import NewText from "@components/NewText";
import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// NotFoundScreen => Rename all instances to use
type NotFoundScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _NotFoundScreen = (props: NotFoundScreenProps) => {
  return (
    <div className={props.className + " screen"}>
      <div className={"main-title"}>
        <NewText _type={"title"} _align={"center"} _text={"Page not found !"} />
      </div>

      <img
        className={"markiplier"}
        src="https://c.tenor.com/FFYqOVVbrJAAAAAC/markiplier-punch.gif"
        alt={"Markiplier punch lol"}
        width={"80%"}
      />
    </div>
  );
};

// ################################ STYLES ################################
const NotFoundScreen = styled(_NotFoundScreen).attrs(
  (props): NotFoundScreenProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: max-content;
    margin-left: auto;
    margin-right: auto;

    .main-title {
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #6a6a6a9d;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .markiplier {
      border-color: #6a6a6a;
      border-width: 2px;
      border-style: solid;
      border-radius: 4px;
      width: 80vw;
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default NotFoundScreen;
